import { backToTop } from "@omni/ui/brand/backToTop/backToTop.style";
import { Button } from "@omni/ui/components/Button/button.component";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { scrollToTop } from "@/utils/scroll";

type BackToTopComponentProps = {
    visible: boolean;
    bottomControlsVisible: boolean;
};

const BackToTopComponent = ({
    visible,
    bottomControlsVisible
}: BackToTopComponentProps) => {
    const { t } = useGranite();

    const { base } = backToTop();

    return (
        <Button
            className={base({
                visible: visible,
                bottomControlsVisible: bottomControlsVisible
            })}
            type={"button"}
            color={"gray"}
            onClick={() => scrollToTop()}
            aria-label={t("accessibility.backToTopButton.label")}
        >
            <i className="las la-angle-up"></i>
        </Button>
    );
};

export { BackToTopComponent };
